export enum UserRole {
    ADMIN = 'ADMIN',
    USER =  'USER',
    GUEST = 'GUEST'
}   

export enum LOGIN_TYPE   {  
    MOBILE = 'mobile',
    EMAIL = 'email',
}

export enum Status {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    PENDING = 'PENDING'
}
export enum Priority {
    HIGH = 'HIGH',
    MEDIUM = 'MEDIUM',
    LOW = 'LOW'
}
export enum AccessLevel {
    READ = 'READ',
    WRITE = 'WRITE',
    EXECUTE = 'EXECUTE'
}
export enum NotificationType {
    EMAIL = 'EMAIL',
    SMS = 'SMS',
    PUSH = 'PUSH'
}

export enum Theme {
    LIGHT = 'LIGHT',
    DARK = 'DARK',
    SYSTEM = 'SYSTEM'
}
export enum Language {
    ENGLISH = 'ENGLISH',
    SPANISH = 'SPANISH',
    FRENCH = 'FRENCH'
}

export enum PaymentStatus {
    PAID = 'PAID',
    UNPAID = 'UNPAID',
    PENDING = 'PENDING'
}
export enum ShippingMethod {
    STANDARD = 'STANDARD',
    EXPRESS = 'EXPRESS',
    OVERNIGHT = 'OVERNIGHT'
}
export enum Currency {
    USD = 'USD',
    EUR = 'EUR',
    GBP = 'GBP'
} 
export enum DayOfWeek {
    SUNDAY = 'SUNDAY',
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY'
}
export enum Month {
    JANUARY = 'JANUARY',
    FEBRUARY = 'FEBRUARY',
    MARCH = 'MARCH',    
    APRIL = 'APRIL',
    MAY = 'MAY',
    JUNE = 'JUNE',
    JULY = 'JULY',
    AUGUST = 'AUGUST',
    SEPTEMBER = 'SEPTEMBER',
    OCTOBER = 'OCTOBER',
    NOVEMBER = 'NOVEMBER',
    DECEMBER = 'DECEMBER'
}
export enum FileType {
    PDF = 'PDF',
    DOCX = 'DOCX',
    XLSX = 'XLSX',
    PNG = 'PNG',
    JPG = 'JPG'
}   
export enum MeasurementUnit {
    METRIC = 'METRIC',
    IMPERIAL = 'IMPERIAL'
}
export enum TimeZone {
    UTC = 'UTC',
    GMT = 'GMT',
    EST = 'EST',
    PST = 'PST'
}
export enum Gender {
    MALE = 'MALE',          
    FEMALE = 'FEMALE',
    OTHER = 'OTHER'
}
export enum MaritalStatus {
    SINGLE = 'SINGLE',
    MARRIED = 'MARRIED',
    DIVORCED = 'DIVORCED',
    WIDOWED = 'WIDOWED'
}   
export enum EducationLevel {
    HIGH_SCHOOL = 'HIGH_SCHOOL',
    BACHELORS = 'BACHELORS',
    MASTERS = 'MASTERS',
    DOCTORATE = 'DOCTORATE'
}

export enum MODE {
    CREATE = 'Create',
    EDIT = 'Edit',
    VIEW = 'View',
    APPROVE= 'Approve',
    REJECT = 'Reject',
    SUSPENDED = 'Suspended',
}

export enum COLOR {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    ACCENT = 'accent',
    WARN= 'warn',
    GHOST= 'ghost',
}

export enum ADMIN_ROLES {
    SUPER_ADMIN = 'super admin',
    ADMIN_EXECUTIVE = 'admin executive',
    SALES = 'sales',
    SUPPORT = 'support',
    FINANCE = 'finance',
    ADMIN_HEAD ='admin head',
    SALES_HEAD = 'sales head',
    SUPPORT_HEAD = 'support head',
    FINANCE_HEAD = 'finance head',
    ADMIN = 'admin',

}

export enum ACTION_MENU_OPTIONS {
    VIEW_DETAILS = 'View Details',
    START_ACTIVATION = 'Start Activation',
    APPROVE_KYC = 'Approve KYC',
    EDIT = 'Edit',
    DELETE = 'Delete',
    VIEW_KYC = 'View KYC Documents',
}